export const CORE_EPOCH_SECOND: number = 1000;
export const CORE_EPOCH_MINUTE: number = 60000;
export const CORE_EPOCH_HOUR: number = 3600000;
export const CORE_EPOCH_DAY: number = 86400000;
export const CORE_EPOCH_WEEK: number = 604800000;
export const CORE_EPOCH_MONTH: number = 2592000000;
export const CORE_EPOCH_YEAR: number = 31536000000;
